import Search from "antd/es/input/Search";
import React, { useEffect } from "react";
import CreateNewOrganizationsButton from "../../Template/Buttons/CreateNewOrganizationsButton";
import CreateNewUsersButton from "../../Template/Buttons/CreateNewUsersButton";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { resetOrganizationsTable, searchOrganizations } from "../../../redux/SettingModule/OrganizationsPage/OrganizationsPageAction";
import { resetUsersTable, searchUsers } from "../../../redux/SettingModule/UsersPage/UsersAction";

interface Props {
  tab: string;
}

function SettingsFilterComponent(props: Props) {
  const [value, setValue] = React.useState("");
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      setValue("");
    };
  }, [props.tab]);

  const handleSearchOrganizations = (searchKeyword: string) => {
    dispatch(resetOrganizationsTable());
    dispatch(searchOrganizations({ searchKeyword }));
  };
  const handleSearchUsers = (searchKeyword: string) => {
    dispatch(resetUsersTable());
    dispatch(searchUsers({ searchKeyword }));
  };

  return (
    <div className="d-flex justify-content-between gap-3">
      <div className="d-flex justify-content-between ">
        <Search
          type="text"
          size="large"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          // onSearch={(value) => onSearchAudios(value)}
          onSearch={(value) => {
            if (props.tab === "organizations") {
              handleSearchOrganizations(value);
            } else if (props.tab === "users") {
              handleSearchUsers(value);
            }
          }}
          allowClear
          placeholder={props.tab === "organizations" ? "Search by organization name..." : "Search by user name..."}
          // onChange={(e) => setSearchValue(e.target.value)}
          style={{ width: 600 }}
        />
      </div>
      <div className="d-flex justify-content-between">
        {props.tab === "organizations" && <CreateNewOrganizationsButton />}
        {props.tab === "users" && <CreateNewUsersButton />}
      </div>
    </div>
  );
}

export default SettingsFilterComponent;
